// =====================================
//
//   Native Login Controller
//   Author: Gray
//   createtime: 2016 / 09 / 27
//
// =====================================

window.InifECMobileApp.controller("NativeLoginController", ['$scope', '$state', '$timeout', '$rootScope', 
	function($scope, $state, $timeout, $rootScope) {
        
        var showLoading = function() {

            $scope.isShowLoading = true;

            $rootScope.$broadcast('OPEN_LOADING_MODAL', {
                title: '與FB連接中',
            });
        }

        var hideLoading = function() {
            
            $scope.isShowLoading = false;
            
            $rootScope.$broadcast('CLOSE_LOADING_MODAL');
        }

        var init = function() {

            $timeout(function() {
                showLoading();

                // 10 秒還卡在此畫面則自動取消
                // $timeout(function() {
                //     if($scope.isShowLoading && $scope.state == window.STATES.NATIVE_LOGIN_MODAL) {
                //         hideLoading();
                //         $state.go(window.STATES.OTHER, {
                //             useNativeLoginModal: $rootScope.useNativeLoginModal
                //         });
                //     }
                // }, 10000);
            });
        }

        //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {

            $scope.state = $state.current.name;

            if($scope.isShowLoading && $scope.state != window.STATES.NATIVE_LOGIN_MODAL) {
                hideLoading();
            }

            if(!$scope.isShowLoading && $scope.state == window.STATES.NATIVE_LOGIN_MODAL) {
                showLoading();
            }
        });

        //==========================
        //  Members
        //==========================
        $scope.isShowLoading = false;
        
        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        init();
	}
]);